<external-api-sync></external-api-sync>